import Highcharts from 'highcharts';

const trackColors = {
  money: '#2caffe',
  ldm: '#00e272',
};

const bgTrackColors = {
  money: new Highcharts.Color(trackColors.money).setOpacity(0.3).get(),
  ldm: new Highcharts.Color(trackColors.ldm).setOpacity(0.3).get(),
};

export const ringsInsightsHighchartsOptions = (moneyPercent: number, ldmPercent: number) => {
  return {
    chart: {
      type: 'solidgauge',
    },
    title: null,
    credits: {
      enabled: false,
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
      background: [
        {
          outerRadius: '100%',
          innerRadius: '75%',
          backgroundColor: bgTrackColors.money,
          borderWidth: 0,
        },
        {
          outerRadius: '75%',
          innerRadius: '50%',
          backgroundColor: bgTrackColors.ldm,
          borderWidth: 0,
        },
      ],
    },
    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
    },
    tooltip: {
      borderWidth: 0,
      backgroundColor: 'none',
      shadow: false,
      style: {
        fontSize: '16px',
      },
      valueSuffix: '%',
      pointFormat: '',
    },
    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: false,
        },
        linecap: 'round',
        stickyTracking: false,
        rounded: false,
        borderRadius: 50,
      },
    },
    series: [
      {
        name: 'Money',
        data: [
          {
            color: trackColors.money,
            outerRadius: '100%',
            innerRadius: '75%',
            y: moneyPercent,
          },
        ],
      },
      {
        name: 'LDM',
        data: [
          {
            color: trackColors.ldm,
            radius: '75%',
            innerRadius: '50%',
            y: ldmPercent,
          },
        ],
      },
    ],
  };
};
